import React from 'react';
function Unusual({text, btonLabel, onClick, type}){
    let cls = 'pic';
    if(type && type == 'pub'){
        cls += ' icon_pub';
    }
    else{
        cls += ' icon_emp';
    }
    return (
        <div className="m-empty f-tc">
            <i className={cls}></i>
            <p className="note s-fc3">{text}</p>
            {
                btonLabel ? (
                    <p className="f-mgt30">
                        <button className="u-nbtn u-nbtn-shadow u-nbtn-blue" onClick={onClick}>{btonLabel}</button>
                    </p>
                ) : null
            }
        </div>
    )
}
export default Unusual;


// WEBPACK FOOTER //
// ./client/component/error.js